import { useEffect, useState } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomeBHero from "@/components/sections/HomeBHero";
import CopilotSection from "@/components/sections/CopilotSection";
import StatsSection from "@/components/sections/StatsSection";
import DiscoverySection from "@/components/sections/DiscoverySection";
import TestimonialsSection from "@/components/sections/TestimonialsSection";
import ContactSection from "@/components/sections/ContactSection";
import api from "@/lib/api";

export default function Landing() {
  const [flags, setFlags] = useState({ show_testimonials: false, show_google_reviews: false });
  useEffect(() => {
    api.get("/settings/public").then((r) => setFlags({
      show_testimonials: !!r.data.show_testimonials,
      show_google_reviews: !!r.data.show_google_reviews,
    })).catch(() => {});
  }, []);
  return (
    <>
      <Header />
      <main data-testid="landing-main">
        <HomeBHero />
        <CopilotSection />
        <StatsSection />
        <DiscoverySection />
        {(flags.show_testimonials || flags.show_google_reviews) && (
          <TestimonialsSection showTestimonials={flags.show_testimonials} showGoogleReviews={flags.show_google_reviews} />
        )}
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}
